import React from 'react'
import styles from './styles.module.css'
import { PALETTE } from '../../../styles/constants'
import Text from '../../Text'
import RichText from './RichText'

function LegalDocumentPage({ legalDocument, textColor = { value: PALETTE.gray80 }, backgroundColor = { value: PALETTE.white } }) {
  const lastUpdatedDate = new Date(legalDocument.lastUpdated || legalDocument._updatedAt)

  return (
    <div className={styles.wrapper} style={{ color: textColor.value, backgroundColor: backgroundColor.value }}>
      <div className={styles.titleWrapper}>
        <Text type="h1">{legalDocument.title.toUpperCase()}</Text>
        <Text type="h5">{`Last Updated: ${formatDate(lastUpdatedDate)}`}</Text>
      </div>
      <div className={styles.textWrapper}>
        <RichText text={legalDocument.text} />
      </div>
    </div>
  )
}

export const formatDate = (date) => {
  let options = { year: 'numeric', month: 'long', day: 'numeric' }
  return date.toLocaleDateString('en-US', options)
}

export default LegalDocumentPage
